module.exports = __webpack_public_path__ + "fonts/Nimbus-Sans-D-OT-Light.c55efc20.woff";